import { getContext, setContext } from 'svelte';
export const ref = (value) => {
    let inner = $state(value);
    return {
        get current() {
            return inner;
        },
        set current(newVal) {
            inner = newVal;
        }
    };
};
const componentsContextKey = 'components';
export const getComponentsMap = () => getContext(componentsContextKey);
export const setComponentsContext = (value) => setContext(componentsContextKey, value);
const astContextKey = 'ast';
export const getAstNode = () => getContext(astContextKey);
export const setAstContext = (value) => setContext(astContextKey, value);
